/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Platform_Row_Trend_LabelInputs */

const en_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} usage trend`)
};

const zh_hans1_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action}使用趋势`)
};

const pt_br2_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`tendência de uso de ${i?.action}`)
};

const es_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tendencia de uso de ${i?.action}`)
};

const fr_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tendance d’usage : ${i?.action}`)
};

const de_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nutzungstrend ${i?.action}`)
};

const ru_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Динамика использования: ${i?.action}`)
};

const it_platform_row_trend_label = /** @type {(inputs: Platform_Row_Trend_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Andamento d'uso di ${i?.action}`)
};

/**
* | output |
* | --- |
* | "{action} usage trend" |
*
* @param {Platform_Row_Trend_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_row_trend_label = /** @type {((inputs: Platform_Row_Trend_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Row_Trend_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_row_trend_label(inputs)
	if (locale === "pt-BR") return pt_br2_platform_row_trend_label(inputs)
	if (locale === "es") return es_platform_row_trend_label(inputs)
	if (locale === "fr") return fr_platform_row_trend_label(inputs)
	if (locale === "de") return de_platform_row_trend_label(inputs)
	if (locale === "ru") return ru_platform_row_trend_label(inputs)
	if (locale === "it") return it_platform_row_trend_label(inputs)
	return en_platform_row_trend_label(inputs)
});